import * as types from './constants';

// Billing Add Credits
export const billingAddCreditsRequest = data => (
  { type: types.BILLING_ADD_CREDITS_REQUEST, payload: data }
);

export const billingAddCreditsDone = data => (
  { type: types.BILLING_ADD_CREDITS_DONE, payload: data }
);

export const billingAddCreditsFailed = errors => (
  { type: types.BILLING_ADD_CREDITS_FAILED, payload: errors }
);

export const billingAddCreditsReset = () => (
  { type: types.BILLING_ADD_CREDITS_RESET }
);